module.exports = __webpack_public_path__ + "static/media/provider_glo.35d8c121.png";